var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApple = function SvgApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.943 19.315c-.922.895-1.94.756-2.909.334-1.031-.43-1.974-.458-3.062 0-1.356.585-2.076.415-2.893-.334C3.47 14.57 4.15 7.338 9.39 7.066c1.271.068 2.161.703 2.91.755 1.112-.226 2.177-.874 3.368-.789 1.431.116 2.501.68 3.216 1.696-2.943 1.77-2.246 5.649.457 6.737-.54 1.421-1.235 2.825-2.398 3.862l.001-.012Zm-4.746-12.3C12.059 4.905 13.769 3.17 15.735 3c.27 2.433-2.211 4.253-3.538 4.015Z",
    fill: "#000624"
  })));
};
export default SvgApple;